import {createSlice, PayloadAction} from '@reduxjs/toolkit'

const initialState = {
  pageVisible: false,
}

export const PkTeamSlice = createSlice({
  name: 'PkTeamWars',
  initialState,
  reducers: {
    setPageVisible: (state, action) => {
      Object.assign(state, {
        pageVisible: action.payload,
      })
    },
  },
  extraReducers: () => {},
})

export default PkTeamSlice.reducer
export const PkTeamActions = PkTeamSlice.actions
